"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcon = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeBrandsSvgIcons = require("@fortawesome/free-brands-svg-icons");

var siteData = {
  facebook: {
    url: "https://www.facebook.com/MAPCMetroBoston",
    icon: _freeBrandsSvgIcons.faFacebookSquare
  },
  twitter: {
    url: "https://twitter.com/MAPCMetroBoston",
    icon: _freeBrandsSvgIcons.faTwitter
  },
  instagram: {
    url: "https://www.instagram.com/mapcmetroboston/",
    icon: _freeBrandsSvgIcons.faInstagram
  }
};

var SocialIcon = function SocialIcon(_ref) {
  var color = _ref.color,
      site = _ref.site,
      props = (0, _objectWithoutProperties2.default)(_ref, ["color", "site"]);
  var _siteData$site = siteData[site],
      url = _siteData$site.url,
      icon = _siteData$site.icon;
  return /*#__PURE__*/React.createElement("a", Object.assign({
    href: url
  }, props), /*#__PURE__*/React.createElement(_reactFontawesome.FontAwesomeIcon, {
    color: color,
    icon: icon,
    size: "2x"
  }));
};

exports.SocialIcon = SocialIcon;